import React, {useEffect, useState} from 'react';
import {FormControl, FormGroup, FormLabel} from "react-bootstrap";
import {useStores} from "../../../stores/Context";

const CreateObjectUrl = ({idObjet, data}) => {
    const {niveauxIndicateurStore} = useStores();

    const [urlNom, setUrlNom] = useState(data ? data?.config.url_nom : '');
    const [urlAdresse, setUrlAdresse] = useState(data ? data?.config.url_url_adress: '');

    /**
     * TOTO: A changer par l'idée du this.formData dans NiveauxIndicateurStore.js
     */
    useEffect(() =>{
        niveauxIndicateurStore.objetUrlNom = urlNom;
        niveauxIndicateurStore.objetUrlAdresse = urlAdresse;
    }, []);

    const handleGetUrlNom = (value) => {
        setUrlNom(value)
        niveauxIndicateurStore.objetUrlNom = value;
    }
    const handleGetUrlAdresse = (value) => {
        setUrlAdresse(value)
        niveauxIndicateurStore.objetUrlAdresse = value;
    }

    const styles = {
        label: {
            color: 'var(--SEIZO-dark, #002335)',
            fontFamily: '"Sofia Pro", serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '130%',
            float: 'left',
            marginBottom: '.5em',
        },
        input: {
            display: 'inline-flex',
            padding: '12px 18px',
            alignItems: 'flex-start',
            gap: '18px',
            borderRadius: '4px',
            border: '1px solid var(--icon-black, #002335)',
            backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
            /* font styles */
            color: 'var(--icon-black, #002335)',
            fontFamily: 'Nunito, serif',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '130%',
        }
    }

    return (
        <div>
            <FormGroup className="mb-3" controlId="exampleForm.ControlInput1">
                <label style={styles.label}>Titre :</label>
                <FormControl
                    style={styles.input}
                    type={"text"}
                    onChange={(e) => handleGetUrlNom(e.target.value)}
                    value={urlNom}
                />
            </FormGroup>

            <FormGroup className="mb-3" controlId="exampleForm.ControlInput1">
                <label style={styles.label}>URL : </label>
                <FormControl
                    style={styles.input}
                    type={"url"}
                    onChange={(e) => handleGetUrlAdresse(e.target.value)}
                    value={urlAdresse}
                    aria-valuemin={13}
                    placeholder={"https://www.example.com"}
                />
            </FormGroup>
        </div>
    );
};

export default CreateObjectUrl;
